import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './blogs.css';

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                setLoading(true);
                const response = await fetch('/upload/data/blogs.json');
                const data = await response.json();

                // Sort by date if available, otherwise by id
                const sorted = data.sort((a, b) => {
                    if (a.date && b.date) {
                        return new Date(b.date) - new Date(a.date);
                    }
                    return 0;
                });

                setBlogs(sorted);
            } catch (err) {
                console.error('Failed to load blogs:', err);
                setBlogs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <section id="blogs" className="blogs-section-3d">
            <div className="blogs-container-3d">
                <div className="blogs-header-3d">
                    <h2 className="blogs-title-3d">Blogs</h2>
                    <p className="blogs-subtitle-3d">Latest posts and tutorials</p>
                </div>

                {loading ? (
                    <div className="blogs-grid-3d">
                        <p>Loading blogs...</p>
                    </div>
                ) : blogs.length === 0 ? (
                    <div className="blogs-grid-3d">
                        <p>No blogs available yet.</p>
                    </div>
                ) : (
                    <div className="blogs-grid-3d">
                        {blogs.map((post) => {
                            // Route based on type: local = internal link, external = external URL
                            const isExternal = post.type === 'external';

                            const cardContent = (
                                <>
                                    {post.thumbnail && (
                                        <div className="blog-card-image-3d">
                                            <img src={post.thumbnail} alt={post.title} />
                                        </div>
                                    )}
                                    <div className="blog-card-content-3d">
                                        <h3 className="blog-card-title-3d">{post.title}</h3>
                                        {post.excerpt && <p className="blog-card-excerpt-3d">{post.excerpt}</p>}
                                        {(post.date || post.readTimeMinutes || post.author) && (
                                            <div className="blog-card-meta-3d">
                                                {post.author?.name && <>By {post.author.name} · </>}
                                                {post.date && <>{new Date(post.date).toLocaleDateString()} · </>}
                                                {post.readTimeMinutes && <>{post.readTimeMinutes} min read</>}
                                            </div>
                                        )}
                                        <div className="blog-card-tags-3d">
                                            {post.tags?.map((t) => <span key={t} className="blog-tag-3d">{t}</span>)}
                                            {isExternal && <span className="blog-tag-3d blog-tag-external-3d">External</span>}
                                        </div>
                                    </div>
                                </>
                            );

                            if (isExternal) {
                                return (
                                    <a
                                        href={post.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        key={post.id}
                                        className="blog-card-3d blog-card-external-3d"
                                    >
                                        {cardContent}
                                    </a>
                                );
                            }

                            return (
                                <Link
                                    to={`/blog/${post.slug}`}
                                    key={post.id}
                                    className="blog-card-3d"
                                >
                                    {cardContent}
                                </Link>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Blogs;
